import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";

export const getCurrentPlatform = (): string => Capacitor.getPlatform();

export const isIosPlatform = (): boolean => Capacitor.getPlatform() == "ios";

export const isAndroidPlatform = (): boolean => Capacitor.getPlatform() == "android";

export const isNativeMobileApp = (): boolean => {
  const override = import.meta.env.REACT_APP_OVERRIDE_NATIVE_PLATFORM;
  return override === "true" || override === "1" || Capacitor.isNativePlatform();
};

export const isAppInForeground = async (): Promise<boolean> => {
  const { isActive } = await App.getState();
  return isActive;
};

export const dismissMobileKeyboard = async (): Promise<void> => {
  const activeElement = document.activeElement;
  if (activeElement instanceof HTMLElement) {
    activeElement.blur();
  }

  if (isNativeMobileApp()) {
    await Keyboard.hide();
  }
};
